<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t('Вход в портал') }}</h2>
        <p>{{ $t('Введите E-mail/Логин') }}</p>
      </div>
      <form @submit.prevent="login">
        <div class="form-group">
          <label class="sr-only" for="username">Email/Логин</label>
          <input
            id="username"
            type="text"
            v-model.trim="username"
            class="form-control"
            :class="{
              invalid:
                ($v.username.$dirty && !$v.username.required)
            }"
            :aria-invalid="$v.username.$dirty && !$v.username.required ? 'true' : 'false'"
            :aria-describedby="$v.username.$dirty && !$v.username.required ? 'username-error' : null"
            placeholder="Email/Логин"
          />
          <small
            id="username-error"
            class="helper-text invalid"
            v-if="$v.username.$dirty && !$v.username.required"
          >
            {{ $t('Поле Email/Логин не должно быть пустым') }}
          </small>
        </div>
        <div class="form-group password">
          <div style="position: relative;">
            <label class="sr-only" for="password">{{ $t('Пароль') }}</label>
            <input
              id="password"
              :type="passwordFieldType"
              v-model.trim="password"
              class="form-control"
              :class="{
                invalid:
                  ($v.password.$dirty && !$v.password.required) ||
                  ($v.password.$dirty && !$v.password.minLength)
              }"
              :aria-invalid="$v.password.$dirty && (!$v.password.required || !$v.password.minLength) ? 'true' : 'false'"
              :aria-describedby="$v.password.$dirty && (!$v.password.required || !$v.password.minLength) ? 'password-error' : null"
              :placeholder="$t('Пароль')"
            />
            <button
              type="button"
              class="password-toggle"
              :aria-label="showPassword ? $t('Скрыть пароль') : $t('Показать пароль')"
              :aria-pressed="showPassword ? 'true' : 'false'"
              @click="showPassword = !showPassword"
            >
              <i
              :class="[
                showPassword ? 'pro-icon-eye-show' : 'pro-icon-eye-hide'
              ]"
                aria-hidden="true"
              />
            </button>
          </div>
          <small
            id="password-error"
            class="helper-text invalid"
            v-if="$v.password.$dirty && !$v.password.required"
          >
            {{ $t('Введите пароль') }}
          </small>
          <small
            id="password-error"
            class="helper-text invalid"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >
            {{ $t('Пароль должен быть') }}
            {{ $v.password.$params.minLength.min }} {{ $t('символов') }}. {{ $t('Сейчас он') }}
            {{ password.length }}
          </small>
        </div>

        <button class="btn btn-default grad" type="submit">{{ $t('Войти') }}</button>

        <div class="esia-section">
          <div class="login-divider">
            <span>{{ $t('или') }}</span>
          </div>

          <button
            class="btn btn-default grad"
            type="button"
            @click="loginEsia"
          >
            {{ $t('Войти через ЕСИ') }}
          </button>
        </div>

        <div class="sign-form-bottom">
          <router-link :to="$i18nRoute({ name: 'send-email' })">{{ $t('Забыли пароль') }}?</router-link>
          <div class="no-accaunt">
            <p>{{ $t('Не зарегистрированы') }}?</p>
            <router-link :to="$i18nRoute({ name: 'register' })">{{ $t('Создайте аккаунт сейчас') }}</router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, minLength } from 'vuelidate/lib/validators'
  import messages from '@/utils/messages'
  import { extractApiErrorMessages } from '@/utils/apiErrors'

  export default {
    name: 'login',
    data: () => ({
      username: '',
      password: '',
      showPassword: false
    }),
    metaInfo () {
      return {
        title: this.$i18n.t('LoginTitleSEO'),
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.$i18n.t('LoginDescriptionSEO'),
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('LoginKeywordsSEO'),
        }]
      }
    },
    validations: {
      username: { required },
      password: { required, minLength: minLength(8) }
    },
    computed: {
      passwordFieldType () {
        return this.showPassword ? 'text' : 'password'
      }
    },
    mounted () {
      if (messages[this.$route.query.message]) {
        this.$message(messages[this.$route.query.message])
      }
    },
    methods: {
      showAuthError (error, fallbackMessage) {
        const messages = extractApiErrorMessages(error, {
          fieldLabels: {
            username: 'Email/Логин',
            email: 'Email',
            password: this.$t('Пароль'),
            pass: this.$t('Пароль')
          }
        })
        const message = messages.length ? messages.join(' ; ') : fallbackMessage

        this.$noty.error(message, {
          killer: true,
          timeout: 3000,
          layout: 'topRight'
        })
      },
      async login () {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }

        const loginForm = {
          username: this.username,
          password: this.password
        }

        try {
          await this.$store.dispatch('login', loginForm)
          const redirect = sessionStorage.getItem('redirectPath')
          redirect ? await this.$router.push(redirect) : await this.$router.go(-1)
          sessionStorage.removeItem('redirectPath')
        } catch (error) {
          this.showAuthError(error, this.$t('Неправильный email или пароль'))
        }
      },

      loginEsia() {
        const locale = this.$i18n.locale || 'ru'
        const apiUrl = process.env.VUE_APP_BACK_URL

        window.location.href = `${apiUrl}${locale}/api/auth/esia/login`
      }
    }
  }
</script>

<style scoped>
.login-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0 15px;
  color: #888;
}
.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
}
.login-divider span {
  padding: 0 10px;
  font-size: 14px;
  color: #999;
}
</style>
